import React from "react";
import { useLocation } from "react-router";

export function RouteSync() {
  const location = useLocation();

  React.useEffect(() => {
    if (location.key === "default") {
      return;
    }

    if (window.self === window.top) {
      return;
    }

    window.parent.postMessage(
      {
        type: "SESSION_ROUTE",
        data: location.pathname,
      },
      "*",
    );
  }, [location]);

  return null;
}
